import { createStore, applyMiddleware, compose } from 'redux';
import  { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk';
import Selector from '../Selectors/index.selector';
//import { curryGetDefaultMiddleware } from '@reduxjs/toolkit/dist/getDefaultMiddleware';


const newStore = configureStore({reducer: Selector })
export default newStore;